import * as tinyMceAngular from '@tinymce/tinymce-angular';

if(window['tinymce'] == null) window['tinymce'] = {};
window['tinymce']['tinymce-angular'] = tinyMceAngular

export { tinyMceAngular };